module.exports = __webpack_public_path__ + "img/dwtm_bron_WKO.svg";